import { PROPERTY_CATEGORIES_FILTER } from "constants/properties/PropertiesConstants";

export const isCategoryNotHousing = (category: string): boolean => {
    return [`${PROPERTY_CATEGORIES_FILTER.C}`, PROPERTY_CATEGORIES_FILTER.G].includes(PROPERTY_CATEGORIES_FILTER[category])
}
